import { render } from "./App.vue?vue&type=template&id=88257efe"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=88257efe&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__